import ServicesContainer from 'modules/services/containers/ServicesContainer';

const ServicesView = props => <ServicesContainer {...props} />;

export default ServicesView;
